import i18n from 'i18next';
import { TransactionType, TransactionTypeValue } from '../services/transaction.types';

// German translations for transaction types
const DE_TRANSACTION_TYPES: Record<number, string> = {
  [TransactionTypeValue.Trade]: 'Trade',
  [TransactionTypeValue.InDeposit]: 'Einzahlung',
  [TransactionTypeValue.OutWithdrawal]: 'Auszahlung',
  [TransactionTypeValue.Transfer]: 'Transfer',
  [TransactionTypeValue.InIncome]: 'Einnahme',
  [TransactionTypeValue.InGiftTip]: 'Geschenk / Trinkgeld',
  [TransactionTypeValue.InRewards]: 'Belohnung / Bonus',
  [TransactionTypeValue.InStaking]: 'Staking',
  [TransactionTypeValue.InMining]: 'Mining',
  [TransactionTypeValue.InAirdrop]: 'Airdrop',
  [TransactionTypeValue.InIncomeNonTaxable]: 'Einnahme (steuerfrei)',
  [TransactionTypeValue.OutSpend]: 'Ausgabe',
  [TransactionTypeValue.OutDonation]: 'Spende',
  [TransactionTypeValue.OutGift]: 'Schenkung',
  [TransactionTypeValue.OutStolen]: 'Gestohlen / Gehackt / Betrug',
  [TransactionTypeValue.OutLost]: 'Verlust',
  [TransactionTypeValue.OutOtherFee]: 'Sonstige Gebühr',
  [TransactionTypeValue.OutExpenseNonTaxable]: 'Ausgabe (steuerfrei)',
  [TransactionTypeValue.SwapWrapNonTaxable]: 'Swap (steuerfrei)',
  [TransactionTypeValue.InMasternode]: 'Masternode',
  [TransactionTypeValue.InMiningCommercial]: 'Mining (kommerziell)',
  [TransactionTypeValue.InMinting]: 'Minting',
  [TransactionTypeValue.InDividends]: 'Dividenden Einnahme',
  [TransactionTypeValue.InLending]: 'Lending Einnahme',
  [TransactionTypeValue.InInterest]: 'Zinsen',
  [TransactionTypeValue.InOther]: 'Sonstige Einnahme',
  [TransactionTypeValue.InAirdropNonTaxable]: 'Airdrop (steuerfrei)',
  [TransactionTypeValue.OutBorrowingFee]: 'Borrowing Gebühr',
  [TransactionTypeValue.OutOtherExpenses]: 'Sonstige Ausgabe',
  [TransactionTypeValue.InMarginProfit]: 'Margin Gewinn',
  [TransactionTypeValue.InDerivativesProfit]: 'Derivate / Futures Gewinn',
  [TransactionTypeValue.OutMarginLoss]: 'Margin Verlust',
  [TransactionTypeValue.OutMarginFee]: 'Margin Gebühr',
  [TransactionTypeValue.OutDerivativesLoss]: 'Derivate / Futures Verlust',
  [TransactionTypeValue.OutSettlementFee]: 'Settlement Gebühr',
  [TransactionTypeValue.MarginTrade]: 'Margin Trade',
  [TransactionTypeValue.DerivativesFutureTrade]: 'Derivate / Futures Trade',
  [TransactionTypeValue.InLpIncome]: 'LP Rewards',
  [TransactionTypeValue.InRemoveLiquidity]: 'Remove Liquidity',
  [TransactionTypeValue.InReceiveLpToken]: 'Receive LP Token',
  [TransactionTypeValue.OutProvideLiquidity]: 'Provide Liquidity',
  [TransactionTypeValue.OutReturnLpToken]: 'Return LP Token',
  [TransactionTypeValue.InReceiveLoan]: 'Darlehen erhalten',
  [TransactionTypeValue.InRemoveCollateral]: 'Collateral erhalten',
  [TransactionTypeValue.OutAddCollateral]: 'Collateral gesendet',
  [TransactionTypeValue.OutRepayLoan]: 'Darlehen zurückgezahlt',
  [TransactionTypeValue.OutLiquidation]: 'Liquidation'
};

// List of transaction types to exclude
const EXCLUDED_TYPES = [
  TransactionTypeValue.InOtherIncomeNonTaxable // Remove this duplicate type
];

/**
 * Get a translated transaction type name based on the current language
 * @param type The transaction type object
 * @returns The translated transaction type
 */
export const getTranslatedType = (type: TransactionType): TransactionType => {
  // Only translate if language is German
  if (!i18n.language.toLowerCase().startsWith('de')) {
    return type;
  }

  // Get German translation if available
  const translatedName = DE_TRANSACTION_TYPES[type.value];
  if (!translatedName) {
    return type;
  }

  // Return a new object with translated name
  return {
    ...type,
    name: translatedName
  };
};

/**
 * Translate an array of transaction types
 * @param types Array of transaction types
 * @returns Array with translated names if language is German
 */
export const translateTransactionTypes = (types: TransactionType[]): TransactionType[] => {
  // Only translate if language is German
  if (!i18n.language.toLowerCase().startsWith('de')) {
    return types;
  }
  
  // Filter out excluded types and translate the rest
  return types
    .filter(type => !EXCLUDED_TYPES.includes(type.value))
    .map(getTranslatedType);
};
